export default {
    name : process.env.VUE_APP_NAME,
    version: require('./package.json').version,
    company: {
        name: process.env.VUE_APP_COMPANY_NAME,
        adminEmail: process.env.VUE_APP_ADMIN_EMAIL
    },
    axiosConfig: {
        baseURL: process.env.VUE_APP_API_BASE_URL,
        responseType: 'json',
        withCredentials: true
    }
}